import { combineReducers } from 'redux';
import authReducer from './reducers/authReducer';
import preRegistrationReducer from './reducers/preRegistration';
import inscriptionReducer from './reducers/inscription';
import departmentsAndMunicipalitiesReducer from './reducers/departmentsAndMunicipalities';

const RootReducers = combineReducers({
  auth: authReducer,
  preRegistration: preRegistrationReducer,
  inscription: inscriptionReducer,
  departmentsAndMunicipalities: departmentsAndMunicipalitiesReducer
});

export default RootReducers;
